import { ACCOUNT_INFO_SET_USER_PROFILE } from '../actions/getUserProfile';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  address: '',
  contact: '',
  message: '',
  paymentType: '',
  remarks: '',
  status: '',
  supervisorId: '',
  userEmail: '',
  userName: '',
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ACCOUNT_INFO_SET_USER_PROFILE:
      return action.payload;
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
